import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultPaginationSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { CiscoFmcApiSettingsDefaults } from './types';

// for doc see https://www.cisco.com/c/en/us/td/docs/security/firepower/623/api/REST/Firepower_Management_Center_REST_API_Quick_Start_Guide_623/Objects_in_the_REST_API.html
export const ciscoFmcDefaults: CiscoFmcApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultPaginationSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  maxConcurrentRequests: 9, // The system cannot accept more than 10 parallel requests from all clients
  maxCapacity: 110, // server limit is 120 requests per minute to avoid 429 Too Many Requests response
  refillRate: 110,
  refillRateIntervalMs: 60_000,
  keepAlive: false,
  defaultSessionTimeoutSec: 30 * 60, // 30 minutes
  defaultPageSize: 100_000,
  maxRefreshTokenRefreshCount: 3,
  emptyDataMaxResendCount: 1,
};
